import React, { PureComponent } from 'react';
import { parsePrice } from '../../../../../../lib/helper.js';

class Modifiers extends PureComponent {
  render() {
    const { modifiersTitle = "", modifiers = [], bulletPoint = '-' } = this.props;
    return (
      <div>
      { modifiersTitle!=="" ? 
        <div className="order-panel-item-modifier-group-title">
          {modifiersTitle}
        </div> : 
        null
      }
      {modifiers.map( (modifier, key) => (
        <div key={key}>
          <li>
            <div className="forced-modifers-body">
              <div className="forced-modifers-description">
                {`${bulletPoint} ${modifier.name}`}
              </div>
              <span className="forced-modifers-description-prices">
                {modifier.price > 0 ? parsePrice(modifier.price): null}
              </span>
            </div>
          </li>
        </div>
      ))}
      </div>
    );
  }
}

export default Modifiers;



// WEBPACK FOOTER //
// ./src/views/CustomerOrderHistory/components/OrderHistoryPanel/OrderHistoryBody/ReceiptDetails/Modifiers.jsx